import React from 'react';
import { DocPageLayout } from '../../components/DocPageLayout';
import { CodeBlock } from '../../components/CodeBlock';
interface CheckoutCustomizingPageProps {
  onNavigate?: (pageId: string) => void;
}
export function CheckoutCustomizingPage({
  onNavigate
}: CheckoutCustomizingPageProps) {
  return <DocPageLayout title="Customizing the Checkout" data-id="element-1159">
      <div className="text-sm text-gray-500 mb-6 -mt-8" data-id="element-1160">
        <button onClick={() => onNavigate?.('overview')} className="hover:underline text-orange-600" data-id="element-1161">
          Overview
        </button>{' '}
        &gt;{' '}
        <button onClick={() => onNavigate?.('checkout')} className="hover:underline text-orange-600" data-id="element-1162">
          &lt;&lt;checkout&gt;&gt;
        </button>{' '}
        &gt; Customizing the Checkout
      </div>

      <p className="text-gray-700 mb-6" data-id="element-1163">
        While the &lt;&lt;checkout&gt;&gt; integration provides a fully hosted
        payment page, you can customize certain aspects to match your brand and
        improve the payer experience.
      </p>

      <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1164">
        Merchant Branding
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1165">
        Display your merchant name and logo on the payment page to build trust
        with your customers.
      </p>
      <CodeBlock language="JSON" title="Branding Configuration" code={`{
  "interaction": {
    "merchant": {
      "name": "Your Store Name",
      "logo": "https://your-site.com/logo.png",
      "url": "https://your-site.com"
    }
  }
}`} data-id="element-1166" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1167">
        Display Controls
      </h2>
      <p className="text-gray-700 mb-4" data-id="element-1168">
        Control which fields and sections are displayed on the payment page.
      </p>
      <CodeBlock language="JSON" title="Display Control Configuration" code={`{
  "interaction": {
    "displayControl": {
      "billingAddress": "HIDE",
      "customerEmail": "HIDE",
      "orderSummary": "SHOW",
      "shipping": "HIDE"
    }
  }
}`} data-id="element-1169" />

      <h2 className="text-2xl font-bold text-gray-900 mt-10 mb-4" data-id="element-1170">
        Available Display Options
      </h2>
      <div className="overflow-x-auto mb-8" data-id="element-1171">
        <table className="w-full text-sm border border-gray-200 rounded-lg overflow-hidden" data-id="element-1172">
          <thead data-id="element-1173">
            <tr className="bg-gray-50" data-id="element-1174">
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1175">
                Option
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1176">
                Values
              </th>
              <th className="text-left px-4 py-3 font-semibold text-gray-900 border-b" data-id="element-1177">
                Description
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200" data-id="element-1178">
            <tr data-id="element-1179">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1180">billingAddress</td>
              <td className="px-4 py-3" data-id="element-1181">SHOW / HIDE</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-1182">
                Show or hide billing address fields
              </td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1183">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1184">customerEmail</td>
              <td className="px-4 py-3" data-id="element-1185">SHOW / HIDE</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-1186">
                Show or hide email field
              </td>
            </tr>
            <tr data-id="element-1187">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1188">orderSummary</td>
              <td className="px-4 py-3" data-id="element-1189">SHOW / HIDE</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-1190">
                Show or hide order summary
              </td>
            </tr>
            <tr className="bg-gray-50/50" data-id="element-1191">
              <td className="px-4 py-3 font-mono text-xs" data-id="element-1192">shipping</td>
              <td className="px-4 py-3" data-id="element-1193">SHOW / HIDE</td>
              <td className="px-4 py-3 text-gray-600" data-id="element-1194">
                Show or hide shipping address
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DocPageLayout>;
}